var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongodb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0278 4.81042L17.8296 6.31648C18.0099 6.59441 18.2052 6.84041 18.4352 7.06951C19.1097 7.73553 19.7383 8.44636 20.3169 9.19715C21.6755 10.9811 22.5919 12.9623 23.2464 15.1049C23.6388 16.4138 23.852 17.7565 23.8679 19.1142C23.9337 23.1732 22.5422 26.6586 19.7366 29.5552C19.2803 30.0146 18.7872 30.436 18.2625 30.8153C17.9845 30.8153 17.8531 30.6021 17.7385 30.4059C17.5299 30.042 17.3911 29.6424 17.3292 29.2275C17.2306 28.7365 17.1658 28.2454 17.1977 27.7384V27.5093C17.1752 27.4604 16.9301 4.92591 17.0278 4.81042Z",
    fill: "#599636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0278 4.76063C16.9949 4.69491 16.962 4.74467 16.9292 4.7766C16.9451 5.10523 16.8306 5.39817 16.6513 5.67798C16.4541 5.9559 16.1931 6.16904 15.9311 6.39814C14.4757 7.6582 13.3302 9.18022 12.4129 10.8825C11.1923 13.1735 10.5632 15.6289 10.3848 18.2137C10.3031 19.1461 10.6796 22.4362 10.9735 23.3854C11.7754 25.9055 13.2157 28.0172 15.0814 29.85C15.5396 30.2913 16.0297 30.7007 16.5367 31.0941C16.6841 31.0941 16.7001 30.9627 16.7339 30.865C16.7985 30.6561 16.8478 30.4427 16.8813 30.2265L17.2099 27.7721L17.0278 4.76063Z",
    fill: "#6CAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8296 31.8124C17.8625 31.4368 18.0428 31.1251 18.239 30.8143C18.0418 30.7326 17.8954 30.5702 17.7808 30.389C17.682 30.2174 17.6003 30.0366 17.5367 29.8491C17.3076 29.1618 17.2588 28.4407 17.193 27.7383V27.313C17.1113 27.3787 17.0944 27.9346 17.0944 28.0172C17.0467 28.7595 16.9482 29.4977 16.7996 30.2265C16.7508 30.5213 16.7179 30.8152 16.5367 31.0772C16.5367 31.1101 16.5367 31.1429 16.5527 31.1917C16.8475 32.0593 16.9283 32.9429 16.978 33.8433V34.1719C16.978 34.5644 16.9621 34.4818 17.2879 34.6132C17.4193 34.6621 17.5658 34.679 17.6972 34.7766C17.7958 34.7766 17.8118 34.6949 17.8118 34.6292L17.763 34.0893V32.5833C17.747 32.3203 17.7958 32.0593 17.8287 31.8133L17.8296 31.8124Z",
    fill: "#C2BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_58",
    x: -4,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_58",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.c5ade461006ee0f6ed74cb0d3af6ced9.svg";
export { ForwardRef as ReactComponent };